// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nv-0";
export var fileList = "_nv-2";
export var removeFileButton = "_nv-1";